import { twJoin } from "tailwind-merge";

import type { TextContent as TextContentT } from "@/api/bale.zod";

const policy = window.trustedTypes?.createPolicy("from-server", {
  // TODO: consider if we need a real sanitizer here, but the values
  // from server are all going to be safe... It just would be nice to
  // mark them as "from server" on receipt, and not on rendering
  createHTML: (html) => html,
});

export function TextContent({ content, className }: { content?: TextContentT; className?: string }) {
  const trustedHTML = content?.html ? (policy?.createHTML(content.html) ?? content.html) : null;
  return (
    <div
      className={twJoin("markdown", className)}
      dangerouslySetInnerHTML={trustedHTML ? { __html: trustedHTML } : undefined}
    >
      {trustedHTML ? undefined : content?.raw}
    </div>
  );
}
